export default __webpack_public_path__ + "static/DW-Apple-Lime-0e756bf0c06e870436d9216c9f12f5d3.svg";